<div (click)="clickGuard($event);" class="loading-modal" id="loading-modal">
    <div class="d-loading" style="min-height: 200px;">
        <div class="loader" style="margin: 50px auto;">Loading...</div>
    </div>
</div>
